import React from 'react';
import { useReveal } from '../hooks/useReveal';
interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  as?: 'div' | 'section' | 'li' | 'article';
}
const EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';

/**
 * Scroll reveal with the exact same motion as before (fade + 22px rise, 0.55s),
 * but implemented with GPU-only CSS transforms and ONE shared
 * IntersectionObserver for the whole page instead of one observer per element.
 */
export function Reveal({
  children,
  delay = 0,
  className,
  as = 'div'
}: RevealProps) {
  const {
    ref,
    shown
  } = useReveal<HTMLElement>();
  const Comp = as as keyof JSX.IntrinsicElements;
  return <Comp ref={ref as never} className={className} style={{
    opacity: shown ? 1 : 0,
    transform: shown ? 'none' : 'translate3d(0, 22px, 0)',
    transition: `opacity 0.55s ${EASE} ${delay}s, transform 0.55s ${EASE} ${delay}s`,
    willChange: shown ? undefined : 'opacity, transform'
  }} data-id="element-225" data-mp="2sthdpqk4yd90">
      {children}
    </Comp>;
}